export default [
  { label: 'esc', width: '12', row: '0', code: 'ESCAPE' },
  { label: 'F1', width: '10', row: '0', code: 'F1' },
  { label: 'F2', width: '10', row: '0', code: 'F2' },
  { label: 'F3', width: '10', row: '0', code: 'F3' },
  { label: 'F4', width: '10', row: '0', code: 'F4' },
  { label: 'F5', width: '10', row: '0', code: 'F5' },
  { label: 'F6', width: '10', row: '0', code: 'F6' },
  { label: 'F7', width: '10', row: '0', code: 'F7' },
  { label: 'F8', width: '10', row: '0', code: 'F8' },
  { label: 'F9', width: '10', row: '0', code: 'F9' },
  { label: 'F10', width: '10', row: '0', code: 'F10' },
  { label: 'F11', width: '10', row: '0', code: 'F11' },
  { label: 'F12', width: '10', row: '0', code: 'F12' },
  { modifiers: ['LEFT_CTRL', 'LEFT_ALT'], label: 'CTRL + ALT + DEL', width: 'full', row: '0', code: 'DELETE' },
  { label: '', width: '10', row: '1', code: '' },
  { label: '1', width: '10', row: '1', code: '1' },
  { label: '2', width: '10', row: '1', code: '2' },
  { label: '3', width: '10', row: '1', code: '3' },
  { label: '4', width: '10', row: '1', code: '4' },
  { label: '5', width: '10', row: '1', code: '5' },
  { label: '6', width: '10', row: '1', code: '6' },
  { label: '7', width: '10', row: '1', code: '7' },
  { label: '8', width: '10', row: '1', code: '8' },
  { label: '9', width: '10', row: '1', code: '9' },
  { label: '0', width: '10', row: '1', code: '0' },
  { label: '-', width: '10', row: '1', code: '-' },
  { label: '=', width: 'full', row: '1', flexGrow: true, code: '=' },
  {
    label: 'backsp',
    width: 'full',
    row: '1',
    flexGrow: true,
    code: 'BACKSPACE',
  },
  { label: 'tab', width: '14', row: '2', code: 'TAB' },
  { label: 'Q', width: '10', row: '2', code: 'q' },
  { label: 'W', width: '10', row: '2', code: 'w' },
  { label: 'E', width: '10', row: '2', code: 'e' },
  { label: 'R', width: '10', row: '2', code: 'r' },
  { label: 'T', width: '10', row: '2', code: 't' },
  { label: 'Y', width: '10', row: '2', code: 'y' },
  { label: 'U', width: '10', row: '2', code: 'u' },
  { label: 'I', width: '10', row: '2', code: 'i' },
  { label: 'O', width: '10', row: '2', code: 'o' },
  { label: 'P', width: '10', row: '2', code: 'p' },
  { label: '[', width: '12', row: '2', code: '[' },
  { label: ']', width: '12', row: '2', code: ']' },
  { label: '|', width: 'full', row: '2', flexGrow: true, code: '|' },
  { label: 'caps', width: '16', row: '3', code: 'caps' },
  { label: 'A', width: '10', row: '3', code: 'a' },
  { label: 'S', width: '10', row: '3', code: 's' },
  { label: 'D', width: '10', row: '3', code: 'd' },
  { label: 'F', width: '10', row: '3', code: 'f' },
  { label: 'G', width: '10', row: '3', code: 'g' },
  { label: 'H', width: '10', row: '3', code: 'h' },
  { label: 'J', width: '10', row: '3', code: 'j' },
  { label: 'K', width: '10', row: '3', code: 'k' },
  { label: 'L', width: '10', row: '3', code: 'l' },
  { label: ';', width: '10', row: '3', code: ';' },
  { label: "'", width: '10', row: '3', code: "'" },
  { label: '"', width: '10', row: '3', code: '"' },
  { label: "@", width: '10', row: '3', code: "@" },
  { label: "#", width: '10', row: '3', code: "#" },
  { label: "&", width: '10', row: '3', code: "&" },
  { label: 'return', width: 'full', row: '3', flexGrow: true, code: 'RETURN' },
  { label: 'shift', width: '20', row: '4', code: 'SHIFT' },
  { label: 'Z', width: '10', row: '4', code: 'z' },
  { label: 'X', width: '10', row: '4', code: 'x' },
  { label: 'C', width: '10', row: '4', code: 'c' },
  { label: 'V', width: '10', row: '4', code: 'v' },
  { label: 'B', width: '10', row: '4', code: 'b' },
  { label: 'N', width: '10', row: '4', code: 'n' },
  { label: 'M', width: '10', row: '4', code: 'm' },
  { label: ',', width: '10', row: '4', code: ',' },
  { label: '.', width: '10', row: '4', code: '.' },
  { label: '/', width: '10', row: '4', code: '/' },
  { label: '!', width: '10', row: '4', code: '!' },
  { label: '?', width: '10', row: '4', code: '?' },
  {
    label: 'shift',
    width: '16',
    row: '4',
    flexGrow: true,
    code: 'RIGHT_SHIFT',
  },
  { label: '▲', width: '10', row: '4', code: 'UP' },
  { label: 'DEL', width: '10', row: '4', code: 'DELETE' },
  { label: 'fn', width: '10', row: '5', code: 'fn' },
  { label: 'ctrl', width: '10', row: '5', code: 'LEFT_CTRL' },
  { label: 'win', width: '10', row: '5', code: 'LEFT_GUI' },
  { label: 'alt', width: '10', row: '5', code: 'LEFT_ALT' },
  { label: '', width: 'full', row: '5', flexGrow: true, code: 'SPACE' },
  { label: 'alt', width: '10', row: '5', code: 'RIGHT_ALT' },
  { label: 'win', width: '10', row: '5', code: 'RIGHT_GUI' },
  { label: '◄', width: '10', row: '5', code: 'LEFT' },
  { label: '▼', width: '10', row: '5', code: 'DOWN' },
  { label: '►', width: '10', row: '5', code: 'RIGHT' },
  { label: ' ', code: 'SPACE' },
  { label: 'control', code: 'LEFT_CTRL' },
  { label: 'meta', code: 'LEFT_GUI' },
  { label: 'alt', code: 'LEFT_ALT' },
  { label: 'Enter', code: 'RETURN' },
  { label: 'Backspace', code: 'BACKSPACE' },
  { label: 'ArrowDown', code: 'DOWN' },
  { label: 'ArrowUp', code: 'UP' },
  { label: 'ArrowLeft', code: 'LEFT' },
  { label: 'ArrowRight', code: 'RIGHT' },
  { label: 'Esc', code: 'ESCAPE' },
  { label: ':', code: ':' },
]
